export const VILOG_URL = process.env.REACT_APP_VILOG_URL as string;
export const API_URL = process.env.REACT_APP_API_URL as string;
export const SHORT_DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT = 'dd/MM/yyyy HH:mm';
export const STOCK_CUSTOMER_ID = -1;
